var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rdb-datastore-dialog',{ref:"dialog",attrs:{"title":"Update Relational Datastore","createLabel":"Update","instance":_vm.instance},on:{"payload":_vm.onPayload}})}
var staticRenderFns = []

export { render, staticRenderFns }